export const theme = {
  yellow: "#ffbd00",
  white: "#fff",
  black: "#000",
  darkGrey: "#181818",
  // darkGrey: "#000",
  black2: "#121212",
  // black2: "#000",
  grey: "#1F1F1E",
};
